window.addEventListener('cart:load:success', function(evt) {
  // Bind to 'cart:load:success' to run any javascript after the cart has loaded in the DOM
  POV.CartDrawer.open();
});

(function(){
  'use strict';

  POV.Searchanise = {
    AutocompleteClose: function() {
      if (typeof Searchanise === 'object' && typeof Searchanise.AutocompleteClose === 'function') {
        Searchanise.AutocompleteClose();
      }
    }
  };

  /*============================================================================
    Drawer modules
    - Based on http://shopify.github.io/Timber/#drawers
  ==============================================================================*/

  POV.Drawers = (function () {
    var Drawer = function (id, position, options) {
      var defaults = {
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + position,
        openClass: 'js-drawer-open',
        dirOpenClass: 'js-drawer-open-' + position
      };

      this.nodes = {
        parent: document.querySelectorAll('body, html'),
        page: document.getElementById('Scrim'),
        moved: document.querySelectorAll('.is-moved-by-drawer')
      };

      this.config = Object.assign({}, defaults, options);
      this.position = position;

      this.drawer = document.getElementById(id);
      this.scrim = document.getElementById('Scrim');

      if (!this.drawer) return false;

      this.drawerIsOpen = false;
      this.init();
    };

    Drawer.prototype.init = function () {
      var openElements = document.querySelectorAll(this.config.open);
      nodesToArray(openElements).forEach(function(elem) {
        elem.addEventListener('click', this.open.bind(this));
      }.bind(this));

      var closeElements = this.drawer.querySelectorAll(this.config.close);
      nodesToArray(closeElements).forEach(function(elem) {
        elem.addEventListener('click', this.close.bind(this));
      }.bind(this));
    };

    Drawer.prototype.open = function (evt) {
      var externalCall = false;

      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        this.activeSource = evt.currentTarget;
      }

      if (this.drawerIsOpen && !externalCall) return this.close();
      if (this.drawerIsOpen) return;

      // Notify the drawer is going to open
      // var beforeEvent = new CustomEvent('beforeDrawerOpen.timber', { detail: this });
      // document.body.dispatchEvent(beforeEvent);

      // Add is-transitioning class to moved elements
      nodesToArray(this.nodes.moved).forEach(function(elem) {
        elem.classList.add('is-transitioning');
      });

      prepareTransition([this.drawer]);

      nodesToArray(this.nodes.parent).forEach(function(node) {
        node.classList.add(this.config.openClass, this.config.dirOpenClass);
      }.bind(this));

      this.drawerIsOpen = true;

      // Run function when drawer opens if set
      if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) === 'function') {
        if (!externalCall) this.config.onDrawerOpen();
      }

      if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
        this.activeSource.setAttribute('aria-expanded', 'true');
      }

      this._touchmoveHandler = function(evt) {
        evt.preventDefault();
      };
      this._clickHandler = function(evt) {
        this.close();
        evt.preventDefault();
      }.bind(this);

      this.nodes.page.addEventListener('touchmove', this._touchmoveHandler);
      this.nodes.page.addEventListener('click', this._clickHandler);

      this.scrim.setAttribute('aria-hidden', 'false');

      // Notify the drawer has opened
      // var afterEvent = new CustomEvent('afterDrawerOpen.timber', { detail: this });
      // document.body.dispatchEvent(afterEvent);
      POV.emit('NavDrawer:open', { position: this.position });
    };

    Drawer.prototype.close = function () {
      if (!this.drawerIsOpen) return;

      // Notify the drawer is going to close
      // var beforeCloseEvent = new CustomEvent('beforeDrawerClose.timber', { detail: this });
      // document.body.dispatchEvent(beforeCloseEvent);

      // Deselect any focused form elements
      document.activeElement.blur();

      // Remove transition classes
      prepareTransition([this.drawer]);
      prepareTransition(nodesToArray(this.nodes.moved));

      nodesToArray(this.nodes.parent).forEach(function(elem) {
        elem.classList.remove(this.config.dirOpenClass, this.config.openClass);
      }.bind(this));

      this.drawerIsOpen = false;

      this.nodes.page.removeEventListener('touchmove', this._touchmoveHandler);
      this.nodes.page.removeEventListener('click', this._clickHandler);

      if (this.activeSource) {
        this.activeSource.setAttribute('aria-expanded', 'false');
      }

      this.scrim.setAttribute('aria-hidden', 'true');

      // Notify the drawer is closed now
      // var afterCloseEvent = new CustomEvent('afterDrawerClose.timber', { detail: this });
      // document.body.dispatchEvent(afterCloseEvent);
      POV.emit('NavDrawer:close', { position: this.position });
    };

    return Drawer;

  })();

  POV.CartDrawer = new POV.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': POV.Cart && POV.Cart.load
  });

  POV.NavDrawer = new POV.Drawers('NavDrawer', 'left');

})();

POV.MenuDrawers = (function() {
  function DropDownMenu(container) {
    this.btn = container;
    this.link = this.btn.querySelector('.header__menu--link, .header__btn');
    this.panel = document.getElementById(this.link.getAttribute('aria-controls'));
    this.panelWrap = this.btn.querySelector('.panel__wrap');
    this.scrim = document.getElementById('Scrim');
    this.search = this.panel.querySelector('input[type="search"]');
    this.cartLink = document.querySelectorAll('.js-drawer-open-right');
    this.closeBtn = document.querySelectorAll('[data-close-menu]');
    
    this.menuIsOpen = false;
    this.menuDelay = 80;
    
    this.init();
  }
  
  DropDownMenu.prototype = Object.assign({}, DropDownMenu.prototype, {
    init: function() {
      this.initEvents();
    },
    
    initEvents: function() {
      var _closeAll = this.closeAll.bind(this);
      var _toggle = this.toggle.bind(this);
      
      this.link.addEventListener('click', _toggle);
      nodesToArray(this.cartLink).forEach(function(elem) {
        elem.addEventListener('click', _closeAll);
      });
      this.scrim.addEventListener('click', _closeAll);
      nodesToArray(this.closeBtn).forEach(function(elem) {
        elem.addEventListener('click', _closeAll);
      });
    },
    
    toggle: function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      
      this.menuIsOpen ? this.close() : this.open(); 
    },
    
    linkClick: function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      
      if (this.menuIsOpen) {
        this.close();
        return;
      }
      
      this.closeAll();
      this.open();  
    },
    
    open: function() {
      this.closeAll();
      this.menuIsOpen = true;

      this.panel.setAttribute('aria-hidden', 'false');
      this.scrim.removeAttribute('aria-hidden');
      this.link.setAttribute('aria-expanded', 'true');
      POV.emit('Menu:open', {});

      if (this.search) this.search.focus();
    },
    
    close: function() {
      if (document.querySelector('[data-js-search-btn]:hover')) {
        // Searchanise open
        if (this.panel.id === 'SearchDrawer') return;
      }

      // Hover on search autocomplete
      if (document.querySelector('.snize-ac-results:hover')) return;

      this.menuIsOpen = false;

      this.panel.setAttribute('aria-hidden', 'true');
      this.scrim.setAttribute('aria-hidden', 'true');
      this.link.setAttribute('aria-expanded', 'false');
      POV.emit('Menu:close', {});

      if (this.search) {
        this.search.blur();
        this.link.focus();

        try {
          if (typeof POV.Searchanise !== 'undefined') {
            POV.Searchanise.AutocompleteClose();
          }
        } catch (e) {
          console.log('Error trying to close Searchanise, Searchanise.AutocompleteClose()', e);
        }
      }
    },
    
    closeAll: function() {
      POV.MenuDrawers.forEach(function(drawer){
        if (drawer.menuIsOpen) drawer.close();
      });
    }  

  });
  
  var MenuDrawers = [];
  nodesToArray(document.querySelectorAll('[data-js-panel]')).forEach(function(elem) {
    MenuDrawers.push(new DropDownMenu(elem));
  });
  
  return MenuDrawers;
  
})();

function prepareTransition(elementsArray) {
  elementsArray.forEach(function(el) {
    // Define the events to listen for
    var transitionEvents = ['transitionend', 'webkitTransitionEnd', 'oTransitionEnd', 'MSTransitionEnd'];

    // Handler to remove 'is-transitioning' class after transition ends
    function transitionEndHandler() {
      el.classList.remove('is-transitioning');
      transitionEvents.forEach(function(eventName) {
        el.removeEventListener(eventName, transitionEndHandler);
      });
    }

    // Add event listeners for each transition event
    transitionEvents.forEach(function(eventName) {
      el.addEventListener(eventName, transitionEndHandler);
    });

    el.classList.add('is-transitioning');
    // Force reflow to ensure the transition is rendered
    el.offsetWidth;

  });
}

function nodesToArray(nodes) {
  return Array.prototype.slice.call(nodes);
}